// extracted by mini-css-extract-plugin
export default {"input":"Input_input__YThmD","input__error":"Input_input__error__QCdxy"};